export class CachePatientTime{
    public businessId: number;
    public patientId: number;
    public time: any;

    constructor(BusinessId, PatientId, Time){
        this.businessId = BusinessId;
        this.patientId = PatientId;
        this.time = Time;
    }
}